"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateWaveStep } from "@/types/waves.types";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
enum CreateWaveNextStepType {
  NEXT = "NEXT",
  SAVE = "SAVE",
}
export default function CreateWaveNextStep(t0) {
  const $ = _c(9);
  const {
    disabled,
    step,
    submitting,
    onClick
  } = t0;
  const stepType = step === CreateWaveStep.DESCRIPTION ? CreateWaveNextStepType.SAVE : CreateWaveNextStepType.NEXT;
  let t1;
  if ($[0] !== disabled || $[1] !== onClick) {
    t1 = <PrimaryButton onClicked={onClick} disabled={disabled} loading={false} padding="tw-px-4 tw-py-2.5">Next</PrimaryButton>;
    $[0] = disabled;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onClick || $[4] !== submitting) {
    t2 = <PrimaryButton onClicked={onClick} disabled={submitting} loading={submitting} padding="tw-px-4 tw-py-2.5">Complete</PrimaryButton>;
    $[3] = onClick;
    $[4] = submitting;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      [CreateWaveNextStepType.NEXT]: t1,
      [CreateWaveNextStepType.SAVE]: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const components = t3;
  return components[stepType];
}